import {executeCrudEpic, Type} from 'lib/crud'
import {dao, name} from 'lib/educationStatus'
import {combineEpics} from 'redux-observable'

export const educationStatusEpics = combineEpics(
    executeCrudEpic(name, Type.LIST)(dao.list),
    executeCrudEpic(name, Type.GET)(dao.get),
)